module.exports = () => {
    const loaderInstance = require('../loaderHelper');
    const loader = loaderInstance(document.querySelector('#braintree-dropin-loader'));
    const placeOrderButton = document.getElementById('place-order-button');
    const { orderData } = document.getElementById('order-data').dataset;
    const { objectId } = document.getElementById('object-id').dataset;
    const wrapper = document.querySelector('.paybylink-wrapper');
    const braintree = window.braintree || {};
    let payByLinkData;

    try {
        payByLinkData = JSON.parse(orderData);
    } catch (e) {
        window.console.error(`Error parsing JSON ${e}`);
        return;
    }

    const dropinCreateCallback = (dropinInstance) => {
        placeOrderButton.addEventListener('click', () => {
            dropinInstance.requestPaymentMethod().then((payload) => {
                loader.show();
                fetch(window.reactSystemData.integrationData.braintreePayByLink.payByLinkAuthorize, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        paymentMethodNonce: payload.nonce,
                        amount: payByLinkData.amount.value,
                        merchantAccountId: payByLinkData.merchantAccount,
                        orderId: payByLinkData.reference,
                        objectId,
                        options: {},
                    }),
                }).then((res) => {
                    loader.hide();
                    if (res.status !== 200) {
                        document.querySelector('.result-messages .error').classList.remove('hidden');
                    } else {
                        placeOrderButton.classList.add('hidden');
                        document.querySelector('.result-messages .success').classList.remove('hidden');
                    }
                });
            }).catch((err) => {
                window.console.error(err);
                loader.hide();
                document.querySelector('.result-messages .error').classList.remove('hidden');
            });
        });
    };


    loader.show();

    braintree.dropin.create({
        authorization: window.reactSystemData.integrationData.braintreePayByLink.BT_DROP_IN_UI_TOKEN,
        container: '#dropin-container',
    }).then((dropinInstance) => {
        loader.hide();
        dropinCreateCallback(dropinInstance);
    }).catch((err) => {
        window.console.error('Error Initializing DropIn:', err);
    });
};
